import React, { Component } from 'react';

const logoPath = require('../../images/logo-white.svg')

class Header extends Component {

  render () {
    return (
      <div id="header">
        <div className="container">
          <header>
              <div className="col-xs-12 col-md-3">
                <div className="logo text-center">
                  <img src={logoPath} className="logo" alt="Book DB Logo" />
                </div>
              </div>
              <div className="header-title col-xs-12 col-md-9 text-center">
                <h1>Berwickshire NATS Library Database</h1>
              </div>
          </header>
        </div>
      </div>
    );
  }
}

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/Layout/Header.js
 **/